import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { documentOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { UserService } from '../../../../services/user.service';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { DateObject, Document_Upload_File, IST_SEMINAR_SPEAKER, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from '../../../../models/common';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstActivitiesSeminarsSpeakersComponent } from '../ist-activities-seminars-speakers/ist-activities-seminars-speakers.component';
import { GridApi } from 'ag-grid-community';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivitySeminar } from 'src/app/models/um/organization';
import { FileService } from 'src/app/services/file.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-ist-activities-seminars-view-modal',
  templateUrl: './ist-activities-seminars-view-modal.component.html',
  styleUrls: ['./ist-activities-seminars-view-modal.component.scss']
})
export class IstActivitiesSeminarsViewModalComponent implements OnInit {

  startminDate: Date
  endminDate: Date
  @Input() public Content: any;
  myDate = new Date(new Date().getTime() - (24 * 60 * 60 * 1000));
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  documaent_attach_list: Document_Upload_File[] = [];
  columnDefs;
  formFields;
  activitiesSeminarsForm: UntypedFormGroup;
  ActivitySessions: UntypedFormGroup;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  files: any[];
  StartDate: Date
  EndDate: Date
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  disabledDates: Date[] = [];
  documentOptions = documentOptionsConstant;
  SeminosList: any = [];
  ApplicationID: any;
  Allfiles = [];
  userType: string = "";
  FilesList = [];
  ScreenFilesList = [];
  gridApi: GridApi;
  selectedRow;
  RequiredSettings = true;
  rowData;
  loadGrid = false;
  gridOptions;
  frameworkComponents;
  operations: any[] = [];
  public activeSpeaker: any = "";
  TempOperations: { name: string; id: string; }[];
  context: any;
  Attachments: any[] = [];
  activityseminar: ActivitySeminar;
  appstatus: boolean;
  staticformFields: any;
  permission: string = "";
  IsFormToched: boolean = false;
  tooltipValue: any;
  Application_Type_ID: string = "";
  isDateModified: boolean = false;
  Full_Date: DateObject;
  submittedresponse: SCREEN_RESPONSE[] = [];
  ModelData: any = null;
  SCREEN_MODEL: any = null;
  title: string = "";
  Status: any;
  SubTypeValues: any;
  SpeakersList: any[] = [];
  screenName: string = '';
  genInfoFieldControls: any;
Currency_ID: string="";
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    public modelRef: NgbActiveModal,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public datepipe: DatePipe,
    public commonService: CommonService,
    public fileService: FileService,


  ) {
    this.files = [];
    this.Allfiles = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {
    this.startminDate = new Date(); this.startminDate.setHours(0, 0, 0, 0);
    this.endminDate = new Date(); this.endminDate.setHours(0, 0, 0, 0);
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
      this.GetScreenConfigControls('SCR-010');
    });

    if (!this.ApplicationID) {
      this.GetIstGenInfoScreenConfigControls();
    }

    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.datashareService.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
     if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.datashareService.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.rowData = [];
    this.appstatus = this.commonService.getIstStatus();
    this.userType = this.userService.getUserType();

    this.files = [];

    this.ActivitySessions = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      FIST_NAME: new UntypedFormControl(""),
      LAST_NAME: new UntypedFormControl(""),
      QUALIFICATION: new UntypedFormControl(""),
      OCCUPATION: new UntypedFormControl(""),
      FileNameExt: new UntypedFormControl(""),
      FILES: new UntypedFormControl(null),
      Attachments: new UntypedFormControl("")
    });

    this.TempOperations = [];
    if (this.Content.heading == 'Add' || this.Content.heading == 'Edit') {
      this.TempOperations.push(
        {
          "name": "Edit",
          "id": "Edit"
        },
        {
          "name": "Delete",
          "id": "Delete"
        }
      );
    }

    if (this.Content.heading == 'View') {
      this.TempOperations.push(
        {
          "name": "View",
          "id": "view"
        }
      );
    }

    if (this.Content.heading === 'Edit') { // Edit mode
      this.permission = "Edit";
      this.activityseminar = new ActivitySeminar();

    } else if (this.Content.heading === 'View') { //View mode 
      this.permission = "view";
    }

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,
      IsScreenGrid: true,
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }

    this.columnDefs = [
      {
        "headerName": "Activity Session Title",
        "field": "TITLE"
      },
      {
        "headerName": "Speaker",
        "field": "FIST_NAME"
      },
      {
        headerName: "",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        width: 50,
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }
    ];

    this.context = { id: this.Content.content.id, componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };

    this.operations = this.TempOperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }
  }


  disable() {
    if (this.activitiesSeminarsForm.controls['TYPE'].value == null || this.activitiesSeminarsForm.controls['TYPE'].value == "" || this.activitiesSeminarsForm.controls['TYPE'].value == undefined) {
      this.activitiesSeminarsForm.controls['SUB_TYPE'].disable();
    } else {
      if (this.Content.heading != 'View') {
        this.activitiesSeminarsForm.controls['SUB_TYPE'].enable();
      }
    }
  }

  getRecordForEdit() {
    let today = new Date(); today.setHours(0, 0, 0, 0);
    this.summaryService.getScreenDataForEdit("api/ISTActivitiesseminars/Edit?RecordID=" + this.Content.content.id).subscribe(result => {

      if (result != null) {
        if (result["ChildList"] != null) {
          this.rowData=[];
          result["ChildList"].forEach(x => {
            this.GetSessionDetails(x);
            this.loadGrid = false;

            this.rowData.push(this.ActivitySessions.value);
            setTimeout(() => {
              this.loadGrid = true;
              document.body.click();
            }, 300);
          });
        }

        this.BindDataToDynamicControls();
        this.BindDataToStaticControls(result);
      }
    });
  }

  SaveActivitySeminors() {

    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields.length > 0) {
        for (let i = 0; i < this.staticformFields.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              //this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }

        let uploadData = new FormData();
        let fileList: any[] = [];
        for (let j = 0; j < this.rowData.length; j++) {
          for (let i = 0; i < this.rowData[j].FILES.length; i++) {
            uploadData.append(this.rowData[j].FILES[i].ID, this.rowData[j].FILES[i].File);
            fileList.push(this.rowData[j].FILES[i]);
            this.rowData[j].FILES[i].File = null;
          }
        }

        this.rowData.forEach(element => {
          let speaker = new IST_SEMINAR_SPEAKER();
          speaker.FILES = [];
          element.FILES?.forEach(file => {

            let speakerFile = new Document_Upload_File();
            speakerFile.ID = file.ID;
            speakerFile.DOCUMENT_NAME = file.DOCUMENT_NAME;
            speakerFile.File = file.File;
            speakerFile.Status = file.Status;

            speaker.FILES.push(speakerFile);
          });

          speaker.FileNameExt = element.fileNameExt;
          speaker.FIST_NAME = element.FIST_NAME;
          speaker.LAST_NAME = element.LAST_NAME;
          speaker.ID = element.ID;
          speaker.OCCUPATION = element.OCCUPATION;
          speaker.QUALIFICATION = element.QUALIFICATION;
          speaker.TITLE = element.TITLE;

          this.SpeakersList.push(speaker);
        });

        this.title = this.staticformFields?.filter(x => x.FIELD_CODE == "TITLE")[0].ControlValue;

        //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
        let FinalControls = _.cloneDeep(this.staticformFields);
        FinalControls.forEach((item) => {
          switch (item.CONTROL) {
            case 10:
              item.ControlValue = null;
              break;
          }
        });
        uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
        uploadData.append("Appid", this.Content.content.id);
        uploadData.append("ModuleID", "2");
        uploadData.append("Status", "1");
        uploadData["Files"] = fileList;
        uploadData.append("IST_SEMINAR_SPEAKER", JSON.stringify(this.SpeakersList));

        if (this.Content.heading == "Add") {
          if (!this.ApplicationID) {
            this.SaveIST_GI_APP().subscribe((res) => {
              if (res.Status === 0) {
                this.ApplicationID = res["TransactionID"];
                this.datashareService.setApplicationID(this.ApplicationID);
                uploadData.append("ApplicationID", this.ApplicationID);
                this.summaryService.FilesInsert("api/ISTActivitiesseminars/Insert", uploadData).subscribe(result => {
                  if (result.Status == 0) {
                    this.commonService.SuccessBanner(this.screenName + ' added successfully');
                    this.modalRef.close();
                    this.commonService.refreshPage(this.ApplicationID);
                  }
                  else {
                    this.commonService.ValidationBanner(result.Message);
                  }
                });
              }
            });

          } else {
            uploadData.append("ApplicationID", this.ApplicationID);
            this.summaryService.FilesInsert("api/ISTActivitiesseminars/Insert", uploadData).subscribe(result => {
              if (result.Status == 0) {
                this.commonService.SuccessBanner(this.screenName + ' added successfully');
                this.modalRef.close();
              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }
            });
          }
        } else {
          let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
          if (!inactiveValueControls || inactiveValueControls.length == 0) {
            uploadData.append("ApplicationID", this.ApplicationID);
            this.summaryService.FilesInsert("api/ISTActivitiesseminars/Update", uploadData).subscribe(result => {
              if (result.Status == 0 || result.ErrorCode == "NOCHANGES") {
                if (result.ErrorCode == "NOCHANGES") {
                  this.getRecordForEdit();
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner(this.screenName + ' updated successfully');
                  this.modalRef.close(uploadData);
                }
              }
              else {
                this.getRecordForEdit();
                this.commonService.ValidationBanner(result.Message);
              }
            });
          } else {
            let dataMsg = inactiveValueControls.join("</br>");
            this.commonService.ValidationBanner(dataMsg);
          }
        }

      }
    }
  }

  RemoveSpeacher(id) {

    var filterData = this.SeminosList.filter(item => {
      return item.ID != id;
    });
    this.SeminosList = [];
    this.SeminosList = filterData;
  }

  public p8(s: boolean): string {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }

  DeleteSavedUpload(item): void {
    this.summaryService.DeleteRecord("api/ISTFileAttachments/DeleteFile?FileID=" + item).subscribe(result => {
      let code = item;
      this.FilesList = this.FilesList.filter(function (sec) {
        return sec.ID != code;
      }, code);
    });
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  SaveSession() {
    if (this.SessionvalidateControls()) {
      var childData = this.ActivitySessions.value;
      if (childData.ID == "") {
        childData.ID = (this.SeminosList.length) + 1 + "";
        this.SeminosList.push(childData);
        this.files = [];
      }
      else {
        this.SeminosList.forEach(x => {
          if (x.ID == childData.ID) {
            x.TITLE = childData["TITLE"];
            x.FIST_NAME = childData["FIST_NAME"];
            x.LAST_NAME = childData["LAST_NAME"];
            x.QUALIFICATION = childData["QUALIFICATION"];
            x.OCCUPATION = childData["OCCUPATION"];
            x.FILES = childData["FILES"];
          }
        });
      }
      this.ActivitySessions.controls["ID"].setValue("");
      this.ActivitySessions.controls["FileNameExt"].setValue("");
      this.ActivitySessions.controls["TITLE"].setValue("");
      this.ActivitySessions.controls["FIST_NAME"].setValue("");
      this.ActivitySessions.controls["LAST_NAME"].setValue("");
      this.ActivitySessions.controls["QUALIFICATION"].setValue("");
      this.ActivitySessions.controls["OCCUPATION"].setValue("");
      this.ActivitySessions.controls["FILES"].setValue(null);
      this.FilesList = [];
    }
  }

  SessionvalidateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.ActivitySessions.value;
    if (formData.TITLE === null || formData.TITLE === "" || formData.TITLE === undefined) {
      $("#SeminorTITLE").addClass("ng-touched ng-invalid validate-error");
      $("#SeminorTITLE").removeClass("ng-untouched ng-valid");
      message += "Please enter  Activity Session Title<br/>";
      isValid = false;
    } else {
      $("#SeminorTITLE").addClass("ng-untouched ng-valid");
      $("#SeminorTITLE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.FIST_NAME === null || formData.FIST_NAME === "") {
      $("#FIST_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#FIST_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter First Name<br/>";
      isValid = false;
    } else {
      $("#FIST_NAME").addClass("ng-untouched ng-valid");
      $("#FIST_NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.OCCUPATION === null || formData.OCCUPATION === "") {
      $("#OCCUPATION").addClass("ng-touched ng-invalid validate-error");
      $("#OCCUPATION").removeClass("ng-untouched ng-valid");
      message += "Please enter Occupation<br/>";
      isValid = false;
    } else {
      $("#OCCUPATION").addClass("ng-untouched ng-valid");
      $("#OCCUPATION").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.QUALIFICATION === null || formData.QUALIFICATION === "") {
      $("#QUALIFICATION").addClass("ng-touched ng-invalid validate-error");
      $("#QUALIFICATION").removeClass("ng-untouched ng-valid");
      message += "Please enter Qualification<br/>";
      isValid = false;
    } else {
      $("#QUALIFICATION").addClass("ng-untouched ng-valid");
      $("#QUALIFICATION").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }
  GetSessionDetails(data) {

    this.files = [];
    this.ActivitySessions.controls["ID"].setValue(data["ID"]);
    if (data["FileNameExt"] != null && data["FileNameExt"] != undefined && data["FileNameExt"] != "") {
      this.ActivitySessions.controls["FileNameExt"].setValue(data["FileNameExt"]);
    }
    else {
      this.ActivitySessions.controls["FileNameExt"].setValue("");
    }
    this.ActivitySessions.controls["TITLE"].setValue(data["TITLE"]);
    this.ActivitySessions.controls["FIST_NAME"].setValue(data["FIST_NAME"]);
    this.ActivitySessions.controls["LAST_NAME"].setValue(data["LAST_NAME"]);
    this.ActivitySessions.controls["QUALIFICATION"].setValue(data["QUALIFICATION"]);
    this.ActivitySessions.controls["OCCUPATION"].setValue(data["OCCUPATION"]);
    this.ActivitySessions.controls["FILES"].setValue(data["FILES"]);
    this.files = data["FileNameExt"];
    this.activeSpeaker = data["ID"];
  }
  showFiles() {
    let files = '';
    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    return files;
  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
  }


  SubmitRecord() {

    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields.length > 0) {
        for (let i = 0; i < this.staticformFields.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }

        let uploadData = new FormData();
        let fileList: any[] = [];
        for (let j = 0; j < this.rowData.length; j++) {
          for (let i = 0; i < this.rowData[j].FILES.length; i++) {
            uploadData.append(this.rowData[j].FILES[i].ID, this.rowData[j].FILES[i].File);
            fileList.push(this.rowData[j].FILES[i]);
            this.rowData[j].FILES[i].File = null;
          }
        }

        this.rowData.forEach(element => {
          let speaker = new IST_SEMINAR_SPEAKER();
          speaker.FILES = [];
          element.FILES?.forEach(file => {

            let speakerFile = new Document_Upload_File();
            speakerFile.ID = file.ID;
            speakerFile.DOCUMENT_NAME = file.DOCUMENT_NAME;
            speakerFile.File = file.File;
            speakerFile.Status = file.Status;

            speaker.FILES.push(speakerFile);
          });

          speaker.FileNameExt = element.fileNameExt;
          speaker.FIST_NAME = element.FIST_NAME;
          speaker.LAST_NAME = element.LAST_NAME;
          speaker.ID = element.ID;
          speaker.OCCUPATION = element.OCCUPATION;
          speaker.QUALIFICATION = element.QUALIFICATION;
          speaker.TITLE = element.TITLE;

          this.SpeakersList.push(speaker);
        });


        this.title = this.staticformFields?.filter(x => x.FIELD_CODE == "TITLE")[0].ControlValue;

        uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
        uploadData.append("Appid", this.Content.content.id);
        uploadData.append("ModuleID", "2");
        uploadData.append("Status", "2");
        uploadData["Files"] = fileList;
        uploadData.append("IST_SEMINAR_SPEAKER", JSON.stringify(this.SpeakersList));

        if (this.Content.heading == "Add") {
          if (!this.ApplicationID) {
            this.SaveIST_GI_APP().subscribe((res) => {
              if (res.Status === 0) {
                this.ApplicationID = res["TransactionID"];
                this.datashareService.setApplicationID(this.ApplicationID);
                uploadData.append("ApplicationID", this.ApplicationID);
                this.summaryService.FilesInsert("api/ISTActivitiesseminars/Insert", uploadData).subscribe(result => {
                  if (result.Status == 0) {
                    this.commonService.SuccessBanner(this.screenName + ' added successfully');
                    this.modalRef.close();
                    this.commonService.refreshPage(this.ApplicationID);
                  }
                  else {
                    this.commonService.ValidationBanner(result.Message);
                  }
                });
              }
            });

          } else {
            uploadData.append("ApplicationID", this.ApplicationID);
            this.summaryService.FilesInsert("api/ISTActivitiesseminars/Insert", uploadData).subscribe(result => {
              if (result.Status == 0) {
                this.commonService.SuccessBanner(this.screenName + ' submitted successfully');
                this.modalRef.close();
              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }
            });
          }
        } else {
          let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
          if (!inactiveValueControls || inactiveValueControls.length == 0) {
            uploadData.append("ApplicationID", this.ApplicationID);
            this.summaryService.FilesInsert("api/ISTActivitiesseminars/Update", uploadData).subscribe(result => {
              if (result.Status == 0 || result.ErrorCode == "NOCHANGES") {
                if (result.ErrorCode == "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner(this.screenName + ' submitted successfully');
                  this.modalRef.close(uploadData);
                }
              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }
            });
          } else {
            let dataMsg = inactiveValueControls.join("</br>");
            this.commonService.ValidationBanner(dataMsg);
          }
        }

      }
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onOperationClick(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  CompareDates(olddate: any, newDate: any): boolean {
    if (olddate != '' && olddate != undefined && olddate != null) {

      let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt) { return true }
      else { return false }
    }
    else
      return false
  }

  add() {
    let modalRef = this.modalService.open(IstActivitiesSeminarsSpeakersComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID, staticformFields: this.staticformFields }
    }
    modalRef.result.then(result => {
      this.loadGrid = false;
      this.rowData.push(result);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
    });
  }

  Edit() {

    let modelRef = this['self'].modalService.open(IstActivitiesSeminarsSpeakersComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content = {
      heading: "Edit",
      content: {
        id: this['self'].selectedRow['ID'], rowData: this['self'].selectedRow,
        ApplicationID: this.ApplicationID, docList: this['self'].selectedRow['FILES']
      }
    }
    modelRef.result.then(result => {
      this["self"].loadGrid = false;
      let value = this['self'].rowData.findIndex(x => x.ID == result.ID);
      this['self'].rowData[value].FILES = [];
      if (value != -1) {
        if (result.FILES.length > 0) {
          result.FILES.forEach((element: any) => {
            this['self'].rowData[value].FILES.push(element);
          });
        }

        this['self'].rowData[value].FIST_NAME = result.FIST_NAME;
        this['self'].rowData[value].FileId = result.FileId;
        this['self'].rowData[value].FileNameExt = result.FileNameExt;
        this['self'].rowData[value].ID = result.ID;
        this['self'].rowData[value].LAST_NAME = result.LAST_NAME;
        this['self'].rowData[value].OCCUPATION = result.OCCUPATION;
        this['self'].rowData[value].QUALIFICATION = result.QUALIFICATION;
        this['self'].rowData[value].TITLE = result.TITLE;

      }
      setTimeout(() => {
        this["self"].loadGrid = true;
        document.body.click();
      }, 300);
    });
  }

  Delete(summaryService, toastrService) {

    let id = this['self'].selectedRow['ID'];
    this['self'].commonService.CheckIsFileIsRefereancedInReviw(id).subscribe((x) => {
      if (x["Status"] == 2 && x["Data"] == false) {
        this.commonService.ValidationBanner(x["Message"]);
      }
      else {
        let name = this['self'].selectedRow['FIST_NAME'] + " " + (this['self'].selectedRow['LAST_NAME'] == null ? " " : this['self'].selectedRow['LAST_NAME']);
        let modalRef = this["self"].modalService.open(DeleteBoxComponent, { backdrop: false });
        modalRef.componentInstance.Content = { heading: 'Delete Speaker', custommessage: 'Are you sure you want to delete the speaker   ' + name + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };

        modalRef.result.then(result => {
          if (result == "okclick") {
            this["self"].loadGrid = false;
            let val = this['self'].rowData.findIndex(x => x.ID == this['self'].selectedRow['ID']);
            if (val != -1) {
              this['self'].rowData.splice(val, 1);
            }
            setTimeout(() => {
              this["self"].loadGrid = true;
              //document.body.click();
            }, 300);
          }
        })
      }
    });


  }

  view() {

    let modalRef = this['self'].modalService.open(IstActivitiesSeminarsSpeakersComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animanimationated: true,
    });
    modalRef.componentInstance.Content = {
      heading: "View",
      content: {
        id: this['self'].selectedRow['ID'], rowData: this['self'].selectedRow,
        ApplicationID: this.ApplicationID, docList: this['self'].selectedRow['FILES']
      }

    }

  }

  close() {
    this.modelRef.dismiss();
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        if (!this.staticformFields?.START_DATE.IS_PASTDATES_ALLOWED) {
          this.startminDate = new Date(); this.startminDate.setHours(0, 0, 0, 0);
        }
        else {
          this.startminDate = null;
        }
        if (!this.staticformFields?.END_DATE.IS_PASTDATES_ALLOWED) {
          this.endminDate = new Date(); this.endminDate.setHours(0, 0, 0, 0);
        }
        else {
          this.endminDate = null;
        }
      });
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, '', (ScreenData) => {
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      this.screenName = ScreenData.NAME;
      this.SubTypeValues = this.staticformFields.find(x => x.FIELD_CODE == 'SUB_TYPE').GROUP_VALUES_LIST;
      let fields = this.staticformFields.filter(x => x.IS_STATIC == false);
      fields.forEach((item) => {
        item.Display_Field = true;
      });
      this.getRecordForEdit();
    });
  }

  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-010";
      sr.RowId = this.Content.content.id;
      sr.AppId = this.ApplicationID;
      this.summaryService.getISTScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (let i = 0; i < this.staticformFields.length; i++) {
            let response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                this.staticformFields[i].Display_Field = true;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  let options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].Display_Field = true;
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                this.staticformFields[i].Display_Field = true;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;

                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    // let formd = this.datepipe.transform(new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER), 'dd-MMM-yyyy');
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }

                }

              }
              else {
                this.staticformFields[i].Display_Field = true;
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.staticformFields[i].Display_Field = true;
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
              }
            }

          }
        }

      });
    }
  }

  BindDataToStaticControls(MainObjData: any) {
    let today = new Date(); today.setHours(0, 0, 0, 0);

    for (let i = 0; i < this.staticformFields?.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "APPLICATION_ID":
          this.staticformFields[i].ControlValue = MainObjData.APPLICATION_ID;
          break;
        case "TYPE":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].ControlValue = MainObjData.TYPE;
          break;
        case "START_DATE":
          this.staticformFields[i].Display_Field = true;

          if (MainObjData.START_DATE != null && MainObjData.START_DATE != "" && MainObjData.START_DATE != undefined) {

            this.StartDate = this.commonService.getdisplayedDate(MainObjData.START_DATE);
            MainObjData.START_DATE = this.StartDate;

            let date = new Date(this.StartDate);
            setTimeout(() => {
              while (date < today) {
                this.disabledDates.push(new Date(date));
                date.setDate(date.getDate() + 1);
              }
            }, 1000);
            if (this.StartDate < today) {
              this.startminDate = this.StartDate
            }
          }

          this.staticformFields[i].ControlValue = MainObjData.START_DATE;
          break;
        case "END_DATE":
          this.staticformFields[i].Display_Field = true;

          if (MainObjData.END_DATE != null && MainObjData.END_DATE != "" && MainObjData.END_DATE != undefined) {

            this.EndDate = this.commonService.getdisplayedDate(MainObjData.END_DATE);
            MainObjData.END_DATE = this.EndDate;
            let date = new Date(this.EndDate);
            setTimeout(() => {
              while (date < today) {
                this.disabledDates.push(new Date(date));
                date.setDate(date.getDate() + 1);
              }
            }, 1000);
            if (this.EndDate < today) {
              this.endminDate = this.EndDate
            }
          }
          this.staticformFields[i].ControlValue = MainObjData.END_DATE;
          break;
        case "TITLE":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].ControlValue = MainObjData.TITLE;
          this.title = MainObjData.TITLE;
          break;
        case "NOTES":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].ControlValue = MainObjData.NOTES;
          break;
        case "SUB_TYPE":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].ControlValue = MainObjData.SUB_TYPE;
          this.staticformFields.find(x => x.FIELD_CODE == 'SUB_TYPE').SourceItems = this.SubTypeValues?.filter(x => x.Parentvalue == MainObjData?.TYPE);
          break;
        case "AGENDA":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].ControlValue = MainObjData.AGENDA;
          break;

      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
      }
    }

  }

  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });
    }
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  uploadchange(event, ques: SCREEN_CONTROL): void {
    //let Flag = true;
    let Isexe = false;
let Is5oMB = false; 
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
        Isexe = true;        
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            //ques.UploadFiles = [];
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
        });

      }
    }
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else {

    }
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }

  singleonChange($event, question) {
    this.IsFormToched = true;

    if (question.FIELD_CODE == 'TYPE') {
      this.staticformFields.find(x => x.FIELD_CODE == 'SUB_TYPE').ControlValue = null;
      this.staticformFields.find(x => x.FIELD_CODE == 'SUB_TYPE').SourceItems = this.SubTypeValues?.filter(x => x.Parentvalue == $event.value);
    }
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");
  }

  validateControls(): boolean {
    
    let isValid = true;
    let message = "";
    this.staticformFields.forEach((item) => {
      if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
        switch (item.CONTROL) {
          case 1:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 2:
          case 3:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 4:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please select ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 5:
          case 11:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 10:

            if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0) && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 6:
            let seletedItem = "";
            for (let c = 0; c < item.SourceItems.length; c++) {
              if (item.SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = item.SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + item.SourceItems[c].value;
              }
            }
            item.ControlValue = seletedItem;
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 7:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 8:
            if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0 && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 9:
            break;
        }
      }
    });

    //Check atleast single field value exists
    if (isValid) {
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter atleast one field. <br/>`;
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }


  ApplyConditions($event, question, makeNull) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];


    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })
    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {

        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }

      });
    }
    else {
      this.UpdateParentChildDetails(question);
    }

    if (makeNull == "Y") {
      this.staticformFields.forEach((con) => {
        if (con.IS_Dependent_Display == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Display == true) {

        }
        if (con.IS_Dependent_Enabled == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Enabled == true) {

        }
      });
    }
  }


  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.staticformFields.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }

  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  GetIstGenInfoScreenConfigControls() {
    this.commonService.GetScreenConfigControls('SCR-001', '', '', (ScreenData) => {
      this.genInfoFieldControls = ScreenData["SCREEN_CONTROL"];
    });
  }

  SaveIST_GI_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.genInfoFieldControls));
    uploadData.append("Appid", '');
    uploadData.append("Application_Type_ID", this.Application_Type_ID);
    uploadData.append("Currency_ID", this.Currency_ID);

    return this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Insert", uploadData);
  }

  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }
}
